const environment = process.env || {};

export const FirebaseConfig = {
	"projectId": environment.REACT_APP_FIREBASE_PROJECT_ID || "garahex-b714d",
	"appId": environment.REACT_APP_FIREBASE_APP_ID || "1:1032571442885:web:c958957a7e5ce833ff82ac",
	"databaseURL": environment.REACT_APP_FIREBASE_DATABASE_URL || "https://garahex-b714d-default-rtdb.asia-southeast1.firebasedatabase.app",
	"storageBucket": environment.REACT_APP_FIREBASE_STORAGE_BUCKET || "garahex-b714d.appspot.com",
	"locationId": environment.REACT_APP_FIREBASE_LOCATION_ID || "asia-east2",
	"apiKey": environment.REACT_APP_FIREBASE_API_KEY || "AIzaSyDzejpIZojykN6xfnWeGBT5WN8Sps1pN3Y",
	"authDomain": environment.REACT_APP_FIREBASE_AUTH_DOMAIN || "garahex-b714d.firebaseapp.com",
	"messagingSenderId": environment.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1032571442885",
	"measurementId": environment.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-33NNTF0H5R",
	"projectNumber": environment.REACT_APP_FIREBASE_PROJECT_NUMBER || "1032571442885",
	"version": "2"
};